import React, { createContext, useContext, useEffect, useState } from "react";
import { listenCmsContent } from "./firestoreCms";

const CmsContext = createContext(null);
export const useCms = () => useContext(CmsContext);

export default function CmsProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const unsub = listenCmsContent(
      (datat) => {

        setContent(data);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      }
    );
    return () => unsub();
  }, []);

  return (
    <CmsContext.Provider value={{ content, loading, error }}>
      {children}
    </CmsContext.Provider>
  );
}

const data = {
  site: {
    name: "دار محمد عطاوي",
    tagline: "لتحفيظ القرآن وتقريب علومه",
    language: "ar",
    direction: "rtl",
    seo: {
      defaultTitle: "دار محمد عطاوي | تحفيظ القرآن وتقريب علومه",
      defaultDescription:
        "برامج لتحفيظ القرآن الكريم وتعليم التجويد بأساليب تقليدية باللوح وأخرى عصرية تناسب جميع الفئات.",
      keywords: [
        "تحفيظ القرآن",
        "التجويد",
        "ورش عن نافع",
        "الرسم والضبط",
        "العلوم الشرعية",
        "الرباط",
      ],
    },
    contact: {
      address: "— يُستكمل —",
      phone: "— يُستكمل —",
      whatsapp: "— يُستكمل —",
      email: "— يُستكمل —",
      mapUrl: "— يُستكمل —",
    },
    cta: {
      primary: { label: "تواصل للتسجيل", href: "/contact" },
      secondary: { label: "تعرّف على البرامج", href: "/programs" },
    },
  },
  pages: {
    home: {
      slug: "/",
      title: "الرئيسية",
      sections: [
        {
          type: "hero",
          title: "دار محمد عطاوي لتحفيظ القرآن وتقريب علومه",
          subtitle:
            "برامج لتحفيظ القرآن الكريم وتعليم قواعد التجويد، بأساليب تجمع بين الطريقة المغربية التقليدية باللوح وأساليب عصرية تناسب مختلف الفئات.",
        },
        {
          type: "features",
          title: "لماذا دار محمد عطاوي؟",
          items: [
            "منهج يجمع بين الأصالة والمعاصرة",
            "حلقات تناسب الأطفال واليافعات والنساء والرجال",
            "ربط المجتمع بكتاب الله وتحبيبه للأجيال الصاعدة",
          ],
        },
        {
          type: "programCards",
          title: "برامجنا",
          items: [
            {
              id: "tahfidh",
              title: "تحفيظ القرآن",
              subtitle: "تقليدي باللوح وعصري بالحلقات",
              href: "/programs#tahfidh",
            },
            {
              id: "tajweed",
              title: "قواعد التجويد",
              subtitle: "نظري وتطبيقي وفق رواية ورش",
              href: "/programs#tajweed",
            },
            {
              id: "rasm",
              title: "الرسم والضبط",
              subtitle: "تصحيح اللوح وضبط الكتابة",
              href: "/programs#rasm",
            },
            {
              id: "sharia",
              title: "العلوم الشرعية",
              subtitle: "مشروع تدريجي (قريباً)",
              href: "/programs#sharia",
            },
          ],
        },
        {
          type: "latestActivities",
          title: "آخر الأنشطة",
          items: ["act-2024-07-05", "act-2024-07-summer", "act-2024-11-10"],
          moreHref: "/activities",
        },
      ],
    },
    about: {
      slug: "/about",
      title: "عن الدار",
      sections: [
        {
          type: "text",
          title: "من نحن؟",
          content:
            "تأسست دار محمد عطاوي لتقديم برامج لتحفيظ القرآن وتعليم قواعد التجويد وتقريب الطلاب من بعض العلوم الشرعية، مفتوحة في وجه عموم المسلمين، وبأساليب متنوعة تناسب جميع الأعمار والمستويات.",
        },
        {
          type: "text",
          title: "رسالتنا",
          content:
            "نسعى لربط المجتمع بكتاب الله، وتشجيع التنافس في حفظه وتجويده، وتربية الأجيال على التعلق بالقرآن.",
        },
        {
          type: "timeline",
          title: "نبذة عن مؤسس الدار",
          items: [
            { date: "1933", text: "الميلاد سنة 1933." },
            { date: "2002-01-07", text: "الوفاة يوم الاثنين 7 يناير 2002." },
          ],
        },
        {
          type: "note",
          title: "صدقة جارية",
          content:
            "يهدف الموقع أيضاً إلى التعريف بأنشطة الدار وبرامجها، واعتبار العمل صدقة جارية عن مؤسس الدار وكل من ساهم فيها.",
        },
      ],
    },
    programs: {
      slug: "/programs",
      title: "البرامج",
      sections: [
        {
          type: "programs",
          programs: [
            {
              id: "tahfidh",
              title: "تحفيظ القرآن الكريم",
              variants: [
                {
                  id: "tahfidh-traditional-men",
                  title: "الطريقة التقليدية (حلقة الرجال)",
                  audience: ["الرجال"],
                  method: [
                    "كتابة اللوح ثم تصحيحه (الرسم والضبط والشكل)",
                    "قراءة للتثبيت قبل الحفظ",
                    "حفظ متقن ثم استظهار",
                    "مراجعة دورية للأحزاب المحفوظة",
                  ],
                  notes: ["وفق رواية ورش عن نافع من طريق الأزرق"],
                },
                {
                  id: "tahfidh-modern",
                  title: "الطريقة العصرية (النساء/اليافعات/الأطفال)",
                  audience: ["النساء", "اليافعات", "الأطفال"],
                  frequency: {
                    women: "حصة أسبوعية",
                    girls: "حصتان أسبوعياً",
                    kids: "ثلاث حصص أسبوعياً",
                  },
                  method: [
                    "تصحيح التلاوة",
                    "استظهار الجديد",
                    "تثبيت القديم",
                    "التكرار الجماعي + التلاوة الفردية",
                  ],
                },
              ],
            },
            {
              id: "tajweed",
              title: "قواعد التجويد",
              variants: [
                {
                  id: "tajweed-traditional-men",
                  title: "حلقة الرجال (تقليدي)",
                  method: [
                    "تطبيق القواعد أثناء الاستظهار",
                    "التركيز على أصول ورش (مد البدل، ترقيق الراء، تغليظ اللام...)",
                  ],
                },
                {
                  id: "tajweed-modern",
                  title: "حلقات النساء/اليافعات/الأطفال (عصري)",
                  method: [
                    "حصة القواعد (نظري)",
                    "حصة تصحيح التلاوة (تطبيقي)",
                    "الاستعانة بمنظومة تحفة الأطفال",
                  ],
                },
              ],
            },
            {
              id: "rasm",
              title: "الرسم والضبط",
              method: [
                "كتابة اللوح",
                "تصحيح رسمًا وضبطًا",
                "استظهار محفوظ/حزب حسب الوقت",
                "حفظ متقن + مراجعة",
              ],
            },
            {
              id: "sharia",
              title: "مشروع العلوم الشرعية (قريباً)",
              note: "إدخال تدريجي حسب توفر الظروف والشروط",
              subjects: [
                "النحو",
                "الفقه",
                "أصول الفقه",
                "العقيدة",
                "علوم القرآن",
                "التفسير",
                "الحديث",
              ],
            },
          ],
        },
      ],
    },
    team: {
      slug: "/team",
      title: "الطاقم التربوي",
      sections: [
        {
          type: "teamGrid",
          members: [
            {
              id: "youssef-boulaich",
              name: "الأستاذ يوسف بولعيش",
              role: "مدرس حلقة الرجال",
              bioShort:
                "مسار في التعليم العتيق والقراءات، وتجربة في التدريس والإمامة.",
              image: "— يُستكمل —",
            },
            {
              id: "maryam-nachati",
              name: "الأستاذة مريم نشاطي",
              role: "معلمة قواعد التجويد وتحفيظ القرآن",
              bioShort: "خريجة دار القرآن، ودورات في القاعدة النورانية وغيرها.",
              image: "— يُستكمل —",
            },
            {
              id: "amina-bouhdou",
              name: "الأستاذة أمينة بوحدو",
              role: "مُحفظة ومعلمة للنساء والأطفال",
              bioShort: "شهادات وتجارب في تعليم القرآن وتجويده.",
              image: "— يُستكمل —",
            },
          ],
        },
      ],
    },
    activities: {
      slug: "/activities",
      title: "الأنشطة",
      sections: [
        {
          type: "timeline",
          filterByYear: true,
          items: [
            {
              id: "act-2019-06-29",
              date: "2019-06-29",
              title: "حفل اختتام العام الدراسي 2018–2019",
              details: "على الساعة 5 بمقر المؤسسة",
            },
            {
              id: "act-2019-07-summer",
              date: "2019-07",
              title: "البرنامج الصيفي المكثف",
              details: "الإثنين إلى الخميس | 11:00–13:00",
            },
            {
              id: "act-2024-07-05",
              date: "2024-07-05",
              title: "حفل اختتام العام الدراسي 2023–2024",
              details: "على الساعة 15:30",
            },
            {
              id: "act-2024-07-summer",
              date: "2024-07",
              title: "الدورة الصيفية المكثفة",
              details: "الإثنين إلى الخميس | 11:30–13:30",
            },
            {
              id: "act-2024-11-10",
              date: "2024-11-10",
              title: "لقاء تواصلي: القرآن بين هداية الرحمان وغواية الشيطان",
              details:
                "على الساعة 10:00 صباحاً | بشراكة مع مؤسسة الحاجة شامة رحمها الله",
            },
          ],
        },
      ],
    },
    contact: {
      slug: "/contact",
      title: "التواصل والتسجيل",
      sections: [
        {
          type: "text",
          title: "معلومات التواصل",
          content:
            "يسعدنا تواصلكم معنا للتسجيل أو الاستفسار. يرجى تعبئة النموذج التالي أو التواصل مباشرة عبر بيانات الاتصال.",
        },
        {
          type: "contactCards",
          items: [
            { label: "العنوان", value: "— يُستكمل —" },
            { label: "الهاتف", value: "— يُستكمل —" },
            { label: "واتساب", value: "— يُستكمل —" },
            { label: "البريد الإلكتروني", value: "— يُستكمل —" },
          ],
        },
        {
          type: "form",
          title: "طلب تسجيل أو معلومات",
          fields: [
            {
              name: "fullName",
              label: "الاسم الكامل",
              type: "text",
              required: true,
            },
            { name: "phone", label: "رقم الهاتف", type: "tel", required: true },
            {
              name: "category",
              label: "الفئة",
              type: "select",
              options: ["طفل", "يافعة", "امرأة", "رجل"],
              required: true,
            },
            {
              name: "program",
              label: "البرنامج",
              type: "select",
              options: [
                "تحفيظ القرآن",
                "قواعد التجويد",
                "الرسم والضبط",
                "العلوم الشرعية",
              ],
              required: true,
            },
            {
              name: "message",
              label: "ملاحظة",
              type: "textarea",
              required: false,
            },
          ],
        },
        {
          type: "map",
          title: "موقع الدار على الخريطة",
          mapUrl: "— يُستكمل —",
        },
      ],
    },
  },
};
